import { withStyles } from "@material-ui/core";

const styles = theme => ({
  "@global": {
    /**
     * Disable the focus outline, which is default on some browsers like
     * chrome when focusing elements
     */
    html: {
      scrollBehavior: 'smooth',
    },
    "*": {
      fontFamily: 'PT Sans Caption, serif !important',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
    },
    "a": {
      color: 'inherit',
      cursor: 'pointer',
      textDecoration: 'none',
      "&:hover": {
        textDecoration: 'none',
      }
    },
    "*:focus": {
      outline: 0
    },
    ".text-white *": {
      color: `${theme.palette.common.white}`
    },
    ".listItemLeftPadding": {
      paddingTop: `${theme.spacing(1.75)}px !important`,
      paddingBottom: `${theme.spacing(1.75)}px !important`,
      paddingLeft: `${theme.spacing(4)}px !important`,
      [theme.breakpoints.down("sm")]: {
        paddingLeft: `${theme.spacing(4)}px !important`
      },
      "@media (max-width:  420px)": {
        paddingLeft: `${theme.spacing(1)}px !important`
      }
    },
    ".text-align-center": {
      textAlign: 'center !important'
    },
    ".text-upper-case": {
      textTransform: "uppercase"
    },
    ".position-relative": {
      position: "relative"
    },
    //Currently is not in use, but maby we will need it
    ".capitalizedFirstLetter": {
      "&::first-letter": {
        textTransform: 'capitalize !important',
      }
    },
    ".row": {
      display: "flex",
      flexWrap: "wrap",
      marginRight: -theme.spacing(2),
      marginLeft: -theme.spacing(2)
    },
    ".lg-mg-top": {
      marginTop: `${theme.spacing(20)}px !important`,
      [theme.breakpoints.down("md")]: {
        marginTop: `${theme.spacing(18)}px !important`
      },
      [theme.breakpoints.down("sm")]: {
        marginTop: `${theme.spacing(16)}px !important`
      },
      [theme.breakpoints.down("xs")]: {
        marginTop: `${theme.spacing(14)}px !important`
      }
    },
    ".lg-mg-bottom": {
      marginBottom: `${theme.spacing(20)}px !important`,
      [theme.breakpoints.down("md")]: {
        marginBottom: `${theme.spacing(18)}px !important`
      },
      [theme.breakpoints.down("sm")]: {
        marginBottom: `${theme.spacing(16)}px !important`
      },
      [theme.breakpoints.down("xs")]: {
        marginBottom: `${theme.spacing(14)}px !important`
      }
    },
    ".lg-p-top": {
      paddingTop: `${theme.spacing(20)}px !important`,
      [theme.breakpoints.down("md")]: {
        paddingTop: `${theme.spacing(18)}px !important`
      },
      [theme.breakpoints.down("sm")]: {
        paddingTop: `${theme.spacing(16)}px !important`
      },
      [theme.breakpoints.down("xs")]: {
        paddingTop: `${theme.spacing(14)}px !important`
      }
    },
    // This styles below are auto applyed on slick sliders
    ".slick-dots li button:before": {
      border: '1px solid #204490 !important',
      width: '8px !important',
      height: '8px !important',
      borderRadius: '999px !important',
      color: '#204490 !important',
      opacity: 'unset !important',
      content: `" " !important`
    },
    ".slick-dots li.slick-active button:before": {
      backgroundColor: '#204490 !important'
    },
    ".slick-dots": {
      bottom: '-45px !important'
    },
    ".cms-text-field": {
      "& *": {
        color: "#fff !important",
      },
      "& fieldset": {
        borderColor: "#fff",
      }
    },
  },
});

function globalStyles() {
  return null;
}

export default withStyles(styles, { withTheme: true })(globalStyles);